import snakecaseKeys from 'snakecase-keys';
import { InjectivePermissionsV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgClaimVoucher extends MsgBase {
    static fromJSON(params) {
        return new MsgClaimVoucher(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectivePermissionsV1Beta1Tx.MsgClaimVoucher.create();
        message.sender = params.sender;
        message.denom = params.denom;
        return InjectivePermissionsV1Beta1Tx.MsgClaimVoucher.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.permissions.v1beta1.MsgClaimVoucher',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'permissions/MsgClaimVoucher',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.permissions.v1beta1.MsgClaimVoucher',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.permissions.v1beta1.MsgClaimVoucher',
            message: proto,
        };
    }
    toBinary() {
        return InjectivePermissionsV1Beta1Tx.MsgClaimVoucher.encode(this.toProto()).finish();
    }
}
